import React, { useState } from 'react';
import { KatIcon } from '@amzn/katal-react';
import { useTranslation } from 'src/utils';
import PIIModal from './PIIModal';

const PersonalData: React.FC = () => {
  const { t } = useTranslation();
  const [showPIIModal, setShowPIIModal] = useState(false);
  return (
    <>
      <button
        data-testid="personal-data-button"
        type="button"
        className="mt-1 cursor-pointer border-0 bg-transparent p-0 text-kat-eastern"
        onClick={() => { setShowPIIModal(true); }}
      >
        {t('personalData')}
        <KatIcon className="ltr:ml-1 rtl:mr-1" name="hint" size="tiny" />

      </button>
      <PIIModal
        isVisible={showPIIModal}
        onClose={() => setShowPIIModal(false)}
      />
    </>
  );
};

export default PersonalData;
